/**
 * Adjust classes for Arabic (RTL) layout
 * @param lang - Current language code
 * @param classStr - Original class string
 * @returns Adjusted class string for Arabic
 */
function arClass( classStr) {


    
    const lang =localStorage.getItem('language') || 'en';
 
    if (lang !== "ar") return classStr

  // Add direction: rtl and text-align: right for RTL support
  let adjustedClasses = classStr + ' [direction:rtl] [text-align:right]';
  
  // Swap some common LTR classes to RTL equivalents
  return adjustedClasses
    // Text alignment
    .replace(/\btext-left\b/g, "text-right")
    .replace(/\btext-right\b/g, "text-left")
    .replace(/\btext-start\b/g, "text-end")
    .replace(/\btext-end\b/g, "text-start")
    
    // Margins
    .replace(/\bml-(\S+)\b/g, "mr-$1")
    .replace(/\bmr-(\S+)\b/g, "ml-$1")
    
    // Paddings
    .replace(/\bpl-(\S+)\b/g, "pr-$1")
    .replace(/\bpr-(\S+)\b/g, "pl-$1")
    
    // Borders
    .replace(/\bborder-l-(\S+)\b/g, "border-r-$1")
    .replace(/\bborder-r-(\S+)\b/g, "border-l-$1")
    .replace(/\bborder-l\b/g, "border-r")
    .replace(/\bborder-r\b/g, "border-l")
    
    // Border radius
    .replace(/\brounded-l-(\S+)\b/g, "rounded-r-$1")
    .replace(/\brounded-r-(\S+)\b/g, "rounded-l-$1")
    .replace(/\brounded-l\b/g, "rounded-r")
    .replace(/\brounded-r\b/g, "rounded-l")
    
    // Space between (for flex/grid children)
    .replace(/\bspace-x-(\S+)\b/g, "space-x-reverse")
    .replace(/\bspace-x-reverse\b/g, "space-x-$1")
    
    // Positioning
    .replace(/\bleft-(\S+)\b/g, "right-$1")
    .replace(/\bright-(\S+)\b/g, "left-$1")
    .replace(/\bleft\b/g, "right")
    .replace(/\bright\b/g, "left")
    
    // Float
    .replace(/\bfloat-left\b/g, "float-right")
    .replace(/\bfloat-right\b/g, "float-left")
    
    // Clear
    .replace(/\bclear-left\b/g, "clear-right")
    .replace(/\bclear-right\b/g, "clear-left")
    
    // Scroll margins/paddings
    .replace(/\bscroll-ml-(\S+)\b/g, "scroll-mr-$1")
    .replace(/\bscroll-mr-(\S+)\b/g, "scroll-ml-$1")
    .replace(/\bscroll-pl-(\S+)\b/g, "scroll-pr-$1")
    .replace(/\bscroll-pr-(\S+)\b/g, "scroll-pl-$1")
    
    // Transform origins
    .replace(/\borigin-left\b/g, "origin-right")
    .replace(/\borigin-right\b/g, "origin-left")
    
    // Insets (when used with left/right)
    .replace(/\binset-x-(\S+)\b/g, function(match, p1) { return 'inset-x-' + p1; }) // Keep as is
    .replace(/\binset-y-(\S+)\b/g, function(match, p1) { return 'inset-y-' + p1; }) // Keep as is
    
    // Flex direction (for horizontal flex containers)
    .replace(/\bflex-row\b/g, "flex-row-reverse")
    .replace(/\bflex-row-reverse\b/g, "flex-row")
    
    // Justify content
    .replace(/\bjustify-start\b/g, "justify-end")
    .replace(/\bjustify-end\b/g, "justify-start")
    
    // Text decoration
    .replace(/\bunderline-offset-left\b/g, "underline-offset-right")
    .replace(/\bunderline-offset-right\b/g, "underline-offset-left")
    
    // Divide (for borders between elements)
    .replace(/\bdivide-x-(\S+)\b/g, "divide-x-reverse")
    .replace(/\bdivide-x-reverse\b/g, "divide-x-$1")
    
    // Handle negative margins and paddings
    .replace(/\b-ml-(\S+)\b/g, "-mr-$1")
    .replace(/\b-mr-(\S+)\b/g, "-ml-$1")
    .replace(/\b-pl-(\S+)\b/g, "-pr-$1")
    .replace(/\b-pr-(\S+)\b/g, "-pl-$1")
    
    // Handle arbitrary values (e.g., ml-[10px])
    .replace(/\bml-\[(.*?)\]\b/g, "mr-[$1]")
    .replace(/\bmr-\[(.*?)\]\b/g, "ml-[$1]")
    .replace(/\bpl-\[(.*?)\]\b/g, "pr-[$1]")
    .replace(/\bpr-\[(.*?)\]\b/g, "pl-[$1]")
    .replace(/\bleft-\[(.*?)\]\b/g, "right-[$1]")
    .replace(/\bright-\[(.*?)\]\b/g, "left-[$1]");
}

// Alternative version that adds inline styles instead of arbitrary values
function arClassWithStyles( classStr) {
    const lang =localStorage.getItem('language') || 'en';
  if (lang !== "ar") return classStr;

  // Swap some common LTR classes to RTL equivalents
  let adjustedClasses = classStr
    // Text alignment
    .replace(/\btext-left\b/g, "text-right")
    .replace(/\btext-right\b/g, "text-left")
    .replace(/\btext-start\b/g, "text-end")
    .replace(/\btext-end\b/g, "text-start")
    
    // Margins
    .replace(/\bml-(\S+)\b/g, "mr-$1")
    .replace(/\bmr-(\S+)\b/g, "ml-$1")
    
    // Paddings
    .replace(/\bpl-(\S+)\b/g, "pr-$1")
    .replace(/\bpr-(\S+)\b/g, "pl-$1")
    
    // Borders
    .replace(/\bborder-l-(\S+)\b/g, "border-r-$1")
    .replace(/\bborder-r-(\S+)\b/g, "border-l-$1")
    .replace(/\bborder-l\b/g, "border-r")
    .replace(/\bborder-r\b/g, "border-l")
    
    // Border radius
    .replace(/\brounded-l-(\S+)\b/g, "rounded-r-$1")
    .replace(/\brounded-r-(\S+)\b/g, "rounded-l-$1")
    .replace(/\brounded-l\b/g, "rounded-r")
    .replace(/\brounded-r\b/g, "rounded-l")
    
    // Space between (for flex/grid children)
    .replace(/\bspace-x-(\S+)\b/g, "space-x-reverse")
    .replace(/\bspace-x-reverse\b/g, "space-x-$1")
    
    // Positioning
    .replace(/\bleft-(\S+)\b/g, "right-$1")
    .replace(/\bright-(\S+)\b/g, "left-$1")
    .replace(/\bleft\b/g, "right")
    .replace(/\bright\b/g, "left")
    
    // Float
    .replace(/\bfloat-left\b/g, "float-right")
    .replace(/\bfloat-right\b/g, "float-left")
    
    // Clear
    .replace(/\bclear-left\b/g, "clear-right")
    .replace(/\bclear-right\b/g, "clear-left")
    
    // Scroll margins/paddings
    .replace(/\bscroll-ml-(\S+)\b/g, "scroll-mr-$1")
    .replace(/\bscroll-mr-(\S+)\b/g, "scroll-ml-$1")
    .replace(/\bscroll-pl-(\S+)\b/g, "scroll-pr-$1")
    .replace(/\bscroll-pr-(\S+)\b/g, "scroll-pl-$1")
    
    // Transform origins
    .replace(/\borigin-left\b/g, "origin-right")
    .replace(/\borigin-right\b/g, "origin-left")
    
    // Insets (when used with left/right)
    .replace(/\binset-x-(\S+)\b/g, function(match, p1) { return 'inset-x-' + p1; }) // Keep as is
    .replace(/\binset-y-(\S+)\b/g, function(match, p1) { return 'inset-y-' + p1; }) // Keep as is
    
    // Flex direction (for horizontal flex containers)
    .replace(/\bflex-row\b/g, "flex-row-reverse")
    .replace(/\bflex-row-reverse\b/g, "flex-row")
    
    // Justify content
    .replace(/\bjustify-start\b/g, "justify-end")
    .replace(/\bjustify-end\b/g, "justify-start")
    
    // Text decoration
    .replace(/\bunderline-offset-left\b/g, "underline-offset-right")
    .replace(/\bunderline-offset-right\b/g, "underline-offset-left")
    
    // Divide (for borders between elements)
    .replace(/\bdivide-x-(\S+)\b/g, "divide-x-reverse")
    .replace(/\bdivide-x-reverse\b/g, "divide-x-$1")
    
    // Handle negative margins and paddings
    .replace(/\b-ml-(\S+)\b/g, "-mr-$1")
    .replace(/\b-mr-(\S+)\b/g, "-ml-$1")
    .replace(/\b-pl-(\S+)\b/g, "-pr-$1")
    .replace(/\b-pr-(\S+)\b/g, "-pl-$1")
    
    // Handle arbitrary values (e.g., ml-[10px])
    .replace(/\bml-\[(.*?)\]\b/g, "mr-[$1]")
    .replace(/\bmr-\[(.*?)\]\b/g, "ml-[$1]")
    .replace(/\bpl-\[(.*?)\]\b/g, "pr-[$1]")
    .replace(/\bpr-\[(.*?)\]\b/g, "pl-[$1]")
    .replace(/\bleft-\[(.*?)\]\b/g, "right-[$1]")
    .replace(/\bright-\[(.*?)\]\b/g, "left-[$1]");
    
  // Add RTL styles
  return adjustedClasses + ' rtl:text-right rtl:text-end';
}

// Helper function to apply RTL styles to an element
function applyRtlStyles(element) {
    const lang =localStorage.getItem('language') || 'en';
  if (lang === "ar") {
    // Add inline styles for direction and text-align
    element.style.direction = 'rtl';
    element.style.textAlign = 'right';
    
    // Alternatively, you can add a class
    element.classList.add('rtl-layout');
  }
}

// CSS to add to your stylesheet
const rtlStyles = `
/* RTL layout styles */
.rtl-layout {
  direction: rtl !important;
  text-align: right !important;
}

/* Global RTL support */
[dir="rtl"] {
  direction: rtl;
  text-align: right;
}

/* Language-based RTL support */
:lang(ar) {
  direction: rtl;
  text-align: right;
}

/* Tailwind RTL overrides for Arabic */
[dir="rtl"] .text-left { text-align: right; }
[dir="rtl"] .text-right { text-align: left; }
[dir="rtl"] .text-start { text-align: end; }
[dir="rtl"] .text-end { text-align: start; }

[dir="rtl"] .ml-1 { margin-left: 0; margin-right: 0.25rem; }
[dir="rtl"] .mr-1 { margin-right: 0; margin-left: 0.25rem; }
[dir="rtl"] .pl-1 { padding-left: 0; padding-right: 0.25rem; }
[dir="rtl"] .pr-1 { padding-right: 0; padding-left: 0.25rem; }

/* Add more overrides as needed */
`;

export { arClass, arClassWithStyles, applyRtlStyles, rtlStyles };